import { useEffect, useState } from 'react';

import css from './AddNewProgram.module.css';

import * as programServices from '../../../../../services/programServices';
import * as tnaServices from '../../../../../services/tnaServices';

import AddEditForm from '../../../_common/elements/forms/AddEditForm';
import FormData from '../../../_common/elements/forms/FormData';
import FormComment from '../../../_common/elements/forms/FormComent';
import FormButtons from '../../../_common/elements/forms/FormButtons';
import { use } from 'react';

function AddNewProgram({data, onAdd, toggleModal, programData, func = 'add'}) {
    const [message, setMessage] = useState({ message: '', color: 'black' }); //check why colors are not changing
    const [tna, setTna] = useState([]);
    const [allPrograms, setAllPrograms] = useState([]);

    let template = {
        programNo: data?.programNo || '',
        programTitle: data?.programTitle || '',
        programTitleShort: data?.programTitleShort || '',
        tnaId: data?.tnaId || '',
        programRevisionNo: data?.programRevisionNo || '',
        programRevisionDate: data?.programRevisionDate || '',
        easaMtoeRev: data?.easaMtoeRev || '',
        ukMtoeRev: data?.ukMtoeRev || '',
        programNotes: data?.programNotes || '',
        // ptProgramId: data?.ptProgramId || '',
    };

    console.log(data);

    const [newData, setNewData] = useState(template);

    useEffect(() => {
        tnaServices
            .getAll(1)
            .then((result) => {
                setTna((state) => result.data || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        programServices
            .getAll(1)
            .then((result) => {
                setAllPrograms((state) => result.data || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Implement create program logic here
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setNewData((state) => ({
            ...state,
            [id]: value,
        }));
    };

    const onAddHandle = (e) => {
        e.preventDefault();
        let pass = handleSubmit(e);
        if (pass) {
            toggleModal();
        }
    };


    const onEdit = (e) => {
        e.preventDefault();
        // console.log(newData);
        const updateData = newData;
        updateData._id = data.programId;
        // console.log(updateData);

        programServices
            .edit(updateData)
            .then((res) => {
                setMessage({
                    message: `${updateData.programTitle} is updated successfully!`,
                    color: 'green',
                });
                toggleModal();
            })
            .catch((err) => {
                setMessage({ message: err.message || 'Unknown error ...', color: 'red' });
            });
    };

    return (
        <AddEditForm>
            <FormData>
                <label className={css.label} htmlFor="programNo">Program ID:{' '}</label>
                <input className={css.input} type="text" id="programNo" value={newData.programNo} onChange={handleChange} disabled />

                <label className={css.label} htmlFor="programTitle">Program Title:</label>
                <input className={css.input} type="text" id="programTitle" value={newData.programTitle} onChange={handleChange} />
                
                <label className={css.label} htmlFor="programTitleShort">Program Title Short:</label>
                <input className={css.input} type="text" id="programTitleShort" value={newData.programTitleShort} onChange={handleChange} />

                <label className={css.label} htmlFor="tnaId">TNA ID:</label>
                <select className={css.select} id="tnaId" value={newData.tnaId} onChange={handleChange}>
                    <option value="">-- Select TNA --</option>
                    {tna.map((x) => (
                        <option key={x.tnaId} value={x.tnaId}>{x.tnaNo} - {x.tnaTitle}</option>
                    ))}
                </select>

                <label className={css.label} htmlFor="programRevisionNo">Program Revision No:</label>
                <input className={css.input} type="number" id="programRevisionNo" value={newData.programRevisionNo} onChange={handleChange} />

                <label className={css.label} htmlFor="programRevisionDate">Program Revision Date:</label>
                <input className={css.input} type="text" id="programRevisionDate" value={newData.programRevisionDate} onChange={handleChange} />

                <label className={css.label} htmlFor="easaMtoeRev">EASA MTOE Rev:</label>
                <input className={css.input} type="number" id="easaMtoeRev" value={newData.easaMtoeRev} onChange={handleChange} />

                <label className={css.label} htmlFor="ukMtoeRev">UK MTOE Rev:</label>
                <input className={css.input} type="number" id="ukMtoeRev" value={newData.ukMtoeRev} onChange={handleChange} />


            </FormData>
            <FormComment>
                <label htmlFor="programNotes">Notes</label>
                <textarea
                    id="programNotes"
                    className={css.textarea}
                    rows="32"
                    onChange={handleChange}
                    value={newData.programNotes}
                ></textarea>
            </FormComment>
            <FormButtons>
                {func === 'add' && (
                    <div className={css.submitButtons}>
                        <button className={css.greenButton} onClick={onAddHandle}>
                            Add program
                        </button>
                    </div>
                )}
                {func === 'edit' && (
                    <div className={css.submitButtons}>
                        <button className={css.orangeButton} onClick={onEdit}>
                            Edit program
                        </button>
                    </div>
                )}
                <button onClick={toggleModal} className={`${css.redButton} ${css.buttonClose}`}>
                    Cancel
                </button>
            </FormButtons>
        </AddEditForm>
    );
}

export default AddNewProgram;
